module.exports = __webpack_public_path__ + "static/media/qa.c1727f84.svg";